import { ComponentSettings } from "../settings/settings";

export const settings = {
  permission: {},
  text: {
    welcome: {
      de: "Willkommen zurück",
      en: "Welcome back",
      nl: "Welkom terug"
    },
    enterDetails: {
      de: "Geben Sie Ihre Daten ein, um sich bei Ihrem Konto anzumelden",
      en: "Enter your details to sign in to your account",
      nl: "Voer uw gegevens in om in te loggen op uw account"
    },
    loginButton: { de: "Anmelden", en: "Log in", nl: "Aanmelden" },
    loginButtonMicrosoft: {
      de: "Mit Microsoft anmelden",
      en: "Sign in with Microsoft",
      nl: "Aanmelden met Microsoft"
    },
    logout: { de: "Abmelden", en: "Logout", nl: "Afmelden" },
    accept: {
      de: "Mit Ihrem Login akzeptieren Sie die",
      en: "By signing in you agree to our",
      nl: "Door in te loggen gaat u akkoord met onze"
    },
    additionalInfoOC: {
      de: "and acknowledge that English is the official language",
      en: "and acknowledge that English is the official language",
      nl: "and acknowledge that English is the official language"
    },
    loginError: {
      de: "Name oder Passwort ist falsch.",
      en: "Name or password is incorrect.",
      nl: "Naam of Wachtwoord is niet correct."
    },
    loginName: {
      de: "Name darf nicht leer sein.",
      en: "Name cannot be blank.",
      nl: "Er is geen Naam ingevuld."
    },
    loginPassword: {
      de: "Passwort darf nicht leer sein.",
      en: "Password cannot be blank.",
      nl: "Er is geen Wachtwoord ingevuld."
    },
    loginEmailError: {
      de: "Bitte geben Sie eine gültige Emailadresse ein",
      en: "Please enter a valid email address.",
      nl: "Voer een geldig e-mailadres in."
    },
    help: {
      de: "Benötigen Sie Hilfe bei der Anmeldung in Ihrem Account?",
      en: "Need help accessing your account?",
      nl: "Hulp nodig bij het inloggen op uw account?"
    },
    twoFactorAuth: {
      de: "Two-factor Authentication",
      en: "Two-factor Authentication",
      nl: "Two-factor Authentication"
    },
    twoFactorText: {
      de: "Geben Sie den Code ein, der an Ihre E-Mail-Adresse gesendet wurde",
      en: "Enter the code that was sent to your email address",
      nl: "Voer de code in die naar je e-mailadres is gestuurd"
    },
    submitCode: {
      de: "Code einreichen",
      en: "Submit Code",
      nl: "Code indienen"
    },
    resendCode: {
      de: "Code erneut senden",
      en: "Resend Code",
      nl: "Code opnieuw verzenden"
    },
    MFAError: {
      de: "Ihr Authentifizierungscode ist falsch",
      en: "Your authentication code is incorrect",
      nl: "Uw verificatiecode is onjuist"
    },
    MFASessionExpired: {
      de: "Ihre Sitzung ist abgelaufen. Sie wurden zur Anmeldeseite weitergeleitet",
      en: "Your session has expired. You have been redirected to the login page",
      nl: "Uw sessie is verlopen. U bent doorgestuurd naar de inlogpagina"
    },

    nameEmailLabel: {
      de: "Benutzername / E-Mail",
      en: "User Name / E-mail",
      nl: "Gebruikersnaam / E-mail"
    },
    inactiveUser: {
      de: "Inaktiver Benutzer",
      en: "Inactive user ",
      nl: "Inactieve gebruiker "
    },
    userDeactivated: {
      de: "Ihr Benutzerkonto wurde deaktiviert. Um Ihr Konto wieder zu aktivieren, wenden Sie sich bitte an den Administrator.",
      en: "Your user account has been deactivated. To reactivate your account please contact the administrator.",
      nl: "Uw gebruikersaccount is gedeactiveerd. Neem contact op met de beheerder om uw account opnieuw te activeren."
    },
    licenseNotAvailable: {
      de: "Die maximale Anzahl an Nutzern wurde erreicht. Bitte wenden Sie sich an Ihre interne Administration, um zusätzlichen Zugang zu beantragen.",
      en: "The maximum number of users has been reached. Please contact your internal administrator to request additional access.",
      nl: "Het maximale aantal gebruikers is bereikt. Neem contact op met uw interne beheerder om extra toegang aan te vragen."
    },
    remainingAttempts: {
      de: "Verbleibende Versuche:",
      en: "Remaining attempts:",
      nl: "Resterende pogingen:"
    },
    notAuthorized: {
      de: "Nicht autorisiert",
      en: "Not Authorized",
      nl: "Geen toestemming"
    }
  },
  list: {},
  url: {
    logo: "./assets/lcm-client-logo-rgb.png",
    landingLogo: "./assets/om-portal-logo.png",
    coopLogoLanding: "./assets/coop-logo-landing.png",
    ocLogo: "./assets/oc-logo.png"
  },
  field: {},
  additionalInfo: {
    minPasswordLength: 8
  }
};

export const auth: ComponentSettings<typeof settings> = settings;
